export class equityDerMarginDetailModel {
// setValue(res){
// if(res){
// }
// }
}